import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { authService } from '@/lib/auth'

interface SessionExpiredDialogProps {
  onNavigate: () => void
}

export function SessionExpiredDialog({ onNavigate }: SessionExpiredDialogProps) {
  const [countdown, setCountdown] = useState(5)
  const navigate = useNavigate()

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          handleNavigate()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const handleNavigate = async () => {
    try {
      await authService.logout()
    } catch (error) {
      console.error('Error during logout:', error)
    }
    navigate('/login?expired=true', { replace: true })
    onNavigate()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-8 max-w-md w-full mx-4 border border-gray-200 dark:border-gray-700">
        <div className="flex flex-col items-center space-y-6">

          {/* Message */}
          <div className="text-center space-y-2">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Session Expired
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Please sign in again to continue
            </p>
          </div>

          {/* Countdown */}
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Redirecting to login page in {countdown} seconds...
            </p>
          </div>

          {/* Action button */}
          <Button
            onClick={handleNavigate}
            className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white shadow-md"
            size="lg"
          >
            Go to Login Now
          </Button>
        </div>
      </div>
    </div>
  )
}

